import Vue from 'vue';
import VueResource from 'vue-resource';
import Router from 'vue-router';

import MiddlewareService from '@/MiddlewareService.js';
import store from '@/store';

const Login = () => import('@/components/login/login');
const Dashboard = () => import('@/components/dashboard/Dashboard');
const Slideshows = () => import('@/components/dashboard/slideShow/Slideshows');
const Events = () => import('@/components/dashboard/events/Events');
const UserGroups = () => import('@/components/users/usersGroup');
const UserList = () => import('@/components/users/usersList');
const Services = () => import('@/components/dashboard/services/services');
const MediaLibrary = () => import('@/components/mediaLibrary/mediaLibrary');
const MediaCategories = () => import('@/components/mediaLibrary/mediaCategories');
const Categories = () => import('@/components/dashboard/categories/categories');
const Shops = () => import('@/components/dashboard/categories/shops');
const ShopsList = () => import('@/components/dashboard/shops/shopsList');
const Offers = () => import('@/components/dashboard/offers/offers');
const MallList = () => import('@/components/malls/mallsList');
const SlideShowMaker = () => import('@/components/dashboard/slideShow/slideShowMaker');
const Statistic = () => import('@/components/statistic/statisticPageView');
const Station = () => import('@/components/malls/stations/stations');
const Parking = () => import('@/components/dashboard/parking/parking');
const Floors = () => import('@/components/dashboard/parking/floors/floors');
const Information = () => import('@/components/information/information');
const R = require('ramda');

Vue.use(Router);
Vue.use(VueResource);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      props: {
        parent: 'login',
        menuName: 'login'
      },
      component: Login
    },
    {
      path: '/published',
      name: 'Published',
      props: {
        parent: 'Published',
        menuName: 'Published'
      },
      component: Dashboard,
    },
    {
      path: '/published/SlideShow/NewSlideShow',
      name: 'NewSlideShow',
      props: {
        parent: 'Published',
        menuName: 'Slideshow'
      },
      component: SlideShowMaker,
    }, {
      path: '/published/SlideShow',
      name: 'Slideshows',
      props: {
        parent: 'Published',
        menuName: 'Slideshow'
      },
      component: Slideshows,
    },
    {
      path: '/published/event',
      name: 'Events',
      props: {
        parent: 'Published',
        menuName: 'Event'
      },
      component: Events
    },
    {
      path: '/published/shop',
      name: 'ShopCategories',
      beforeEnter: async(to, from, next) => {
        const data = await MiddlewareService.processRequest(`/Category/${1}?mallId=${localStorage.mallId}`);
        if (data && data.body && data.body.message) {
          store.commit('setCategories', data.body.message);
        }
        next();
      },
      props: {
        parent: 'Published',
        type: 1,
        menuName: 'Shop'
      },
      component: Categories
    },
    {
      path: '/Published/RestaurantAndCafe',
      name: 'RestaurantCategories',
      beforeEnter: async(to, from, next) => {
        const data = await MiddlewareService.processRequest(`/Category/${2}?mallId=${localStorage.mallId}`);
        if (data && data.body && data.body.message) {
          store.commit('setCategories', data.body.message);
        }
        next();
      },
      props: {
        parent: 'Published',
        type: 2,
        menuName: 'RestaurantAndCafe'
      },
      component: Categories
    },
    {
      path: '/Published/ServiceCompany',
      name: 'ServiceCategory',
      beforeEnter: async(to, from, next) => {
        const data = await MiddlewareService.processRequest(`/Category/${3}?mallId=${localStorage.mallId}`);
        if (data && data.body && data.body.message) {
          store.commit('setCategories', data.body.message);
        }
        next();
      },
      props: {
        parent: 'Published',
        type: 3,
        menuName: 'ServiceCompany'
      },
      component: Categories
    },
    {
      path: '/published/shops/:id',
      name: 'Shops',
      props: {
        parent: 'Published',
        type: 1,
        menuName: 'Shop'
      },
      component: Shops
    },
    {
      path: '/Published/RestaurantAndCafe/:id',
      name: 'Restaurants',
      props: {
        parent: 'Published',
        type: 2,
        menuName: 'RestaurantAndCafe'
      },
      component: Shops
    },
    {
      path: '/Published/ServiceCompany/:id',
      name: 'ServiceCompany',
      props: {
        parent: 'Published',
        type: 3,
        menuName: 'ServiceCompany'
      },
      component: Shops
    },
    {
      path: '/published/Shops',
      name: 'ShopsList',
      props: {
        parent: 'Published',
        type: 1,
        menuName: 'Shops'
      },
      component: ShopsList
    },
    {
      path: '/published/Restaurants',
      name: 'RestaurantsList',
      props: {
        parent: 'Published',
        type: 2,
        menuName: 'Restaurants'
      },
      component: ShopsList
    },
    {
      path: '/published/ServiceCompanies',
      name: 'ServiceCompanies',
      props: {
        parent: 'Published',
        type: 3,
        menuName: 'ServiceCompanies'
      },
      component: ShopsList
    },
    {
      path: '/published/service',
      name: 'Service',
      props: {
        parent: 'Published',
        menuName: 'Service'
      },
      component: Services
    },
    {
      path: '/published/Parking',
      name: 'Parking',
      props: {
        parent: 'Published',
        menuName: 'Parking'
      },
      component: Parking
    },
    {
      path: '/published/Parking/:floorId',
      name: 'Floor',
      props: {
        parent: 'Published',
        menuName: 'Parking'
      },
      component: Floors
    },
    {
      path: '/published/offer',
      name: 'Offer',
      props: {
        parent: 'Published',
        menuName: 'Offer'
      },
      component: Offers
    },
    {
      path: '/user/usergroup',
      name: 'Groups',
      props: {
        parent: 'user',
        menuName: 'UserGroup'
      },
      component: UserGroups
    },
    {
      path: '/user/user',
      name: 'users',
      beforeEnter: async(to, from, next) => {
        const data = await MiddlewareService.processRequest('/User');
        if (data && data.body && data.body.success) {
          store.commit('setUsers', data.body.message);
        }
        next();
      },
      props: {
        parent: 'user',
        menuName: 'User'
      },
      component: UserList
    },
    {
      path: '/user/user/:groupId',
      name: 'usersByGroupId',
      props: {
        parent: 'user',
        menuName: 'UserGroup'
      },
      component: UserList
    },
    {
      path: '/MediaLibrary',
      name: 'MediaLibrary',
      props: {
        name: 'Media Library',
        menuName: 'MediaLibrary',
        parent: 'MediaLibrary',
      },
      component: MediaLibrary
    },
    {
      path: '/mediaLibrary/Categories',
      name: 'MediaCategories',
      props: {
        name: 'Media Categories',
        menuName: 'MediaCategories',
        parent: 'MediaLibrary',
      },
      component: MediaCategories
    },
    {
      path: '/mediaLibrary/Document',
      name: 'Document',
      beforeEnter: async(to, from, next) => {
        const data = await MiddlewareService.processRequest(`/MediaLibrary/Files/Document/${localStorage.mallId}`);
        // eslint-disable-next-line no-return-assign
        if (data && data.body && data.body.success) {
          // eslint-disable-next-line no-return-assign
          store.commit('setMediaItems', R.forEach(i => i.url, data.body.message.data));
        }
        next();
      },
      props: {
        parent: 'MediaLibrary',
        name: 'Documents',
        menuName: 'Document'
      },
      component: MediaLibrary
    },
    {
      path: '/MediaLibrary/Image',
      name: 'Image',
      beforeEnter: async(to, from, next) => {
        const data = await MiddlewareService.processRequest(`/MediaLibrary/Files/Image/${localStorage.mallId}`);
        // eslint-disable-next-line no-return-assign
        if (data && data.body && data.body.success) {
          // eslint-disable-next-line no-return-assign
          store.commit('setMediaItems', R.forEach(i => i.url, data.body.message.data));
        }
        next();
      },
      props: {
        parent: 'MediaLibrary',
        name: 'Images',
        menuName: 'Image'
      },
      component: MediaLibrary
    },
    {
      path: '/MediaLibrary/Video',
      name: 'Video',
      beforeEnter: async(to, from, next) => {
        const data = await MiddlewareService.processRequest(`/MediaLibrary/Files/Video/${localStorage.mallId}`);
        // eslint-disable-next-line no-return-assign
        if (data && data.body && data.body.success) {
          // eslint-disable-next-line no-return-assign
          store.commit('setMediaItems', R.forEach(i => i.url, data.body.message.data));
        }
        next();
      },
      props: {
        parent: 'MediaLibrary',
        name: 'Videos',
        menuName: 'Video'
      },
      component: MediaLibrary
    },
    {
      path: '/MediaLibrary/Font',
      name: 'Font',
      props: {
        parent: 'MediaLibrary',
        name: 'Fonts',
        menuName: 'Font'
      },
      component: MediaLibrary
    }, {
      path: '/Statistics',
      name: 'Statistic',
      props: {
        name: 'Statistic',
        menuName: 'Statistic',
        parent: 'Statistic',
      },
      component: Statistic
    },
    {
      path: '/Malls/Mall',
      name: 'malls',
      props: {
        parent: 'malls',
        menuName: 'Mall'
      },
      component: MallList
    }, {
      path: '/Malls/Stations/:id',
      name: 'Stations',
      props: {
        parent: 'malls',
        menuName: 'Mall'
      },
      component: Station
    }, {
      path: '/InfoPage',
      name: 'Information',
      props: {
        parent: 'Information',
        menuName: 'Information',
        name: 'Information',
      },
      component: Information
    }
  ]
});

router.beforeEach((to, from, next) => {
  const app = router.app;
  const mallId = localStorage.mallId;
  const userId = localStorage.userId;
  const userName = localStorage.userName;
  const token = localStorage.token;
  if (mallId === undefined || userId === undefined || userName === undefined || token === undefined) {
    localStorage.removeItem('mallId');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('token');
  }
  if (!mallId && !userId && !userName && !token) {
    localStorage.removeItem('mallId');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('token');
  }
  if (!app.$store) {
    next();
  } else if (!mallId && !userId && !userName && !token) {
    to.path === '/' ? next() : next({ path: "/" });
  } else if (mallId === undefined || userId === undefined || userName === undefined || token === undefined) {
    to.path === '/' ? next() : next({ path: "/" });
  } else {
    next();
  }
});

Vue.http.interceptors.push(function(request, next) {
  next(function(response) {
    if (response.status === 401) {
      router.replace('/');
    } else if (response.status === 403) {
      router.replace('/');
    }
  });
});

export default router;
